/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_Edit_TitleInputs */



/**
* | output |
* | --- |
* | "Edit Speaker" |
*
* @param {Speaker_Manager_Edit_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_edit_title = /** @type {((inputs?: Speaker_Manager_Edit_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_Edit_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier le locuteur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sprecher bearbeiten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifica relatore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Редактировать спикера")
	if (locale === "es") return /** @type {LocalizedString} */ ("Editar orador")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("编辑发言人")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカーを編集")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्पीकर संपादित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Editar alto-falante")
	return /** @type {LocalizedString} */ ("Edit Speaker")
});